module.exports = __webpack_public_path__ + "img/2-3-1.fe058e19.png";